import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { loadStripe, Stripe, StripeCardElement } from '@stripe/stripe-js';
import { loadScript, PayPalNamespace } from '@paypal/paypal-js';
import { CommanUsesService } from './../../services/comman-uses.service';
import { AuthService } from 'src/app/services/auth.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { CustomSale } from 'src/app/models/custom-sale.schema';
import { CustomPaymentsService } from 'src/app/services/custom-payments.service';

@Component({
  selector: 'app-custom-sale-payment',
  templateUrl: './custom-sale-payment.component.html',
  styleUrls: ['./custom-sale-payment.component.scss']
})
export class CustomSalePaymentComponent implements OnInit, AfterViewInit, OnDestroy {
// export class CustomSalePaymentComponent implements OnInit, OnDestroy {

  customSale: CustomSale | null = null;

  private stripe: Stripe | null = null;
  private elements: any;
  private card: StripeCardElement | null = null;
  private paypal: PayPalNamespace | null = null;

  constructor(
    private route: ActivatedRoute,
    private commanUsesService: CommanUsesService,
    private jwtHelper: JwtHelperService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private CustomPaymentsService: CustomPaymentsService,
  ) {}

  async ngOnInit() {
    this.spinnerService.show();

    try {
      const token = this.route.snapshot.params['token'];

      // Validate token format first
      if (!token || token.split('.').length !== 3) {
        this.commanUsesService.showSnackBar('INVALID_PAYMENT_LINK');
        return;
      }

      let expired = false;
      try {
        expired = this.jwtHelper.isTokenExpired(token);
      } catch (err) {
        console.error('JWT decode error:', err);
        this.commanUsesService.showSnackBar('INVALID_OR_EXPIRED_LINK');
        return;
      }

      if (expired) {
        this.commanUsesService.showSnackBar('PAYMENT_LINK_EXPIRED');
        return;
      }

      const decoded: any = this.jwtHelper.decodeToken(token);
      if (!decoded?.customSaleId) {
        this.commanUsesService.showSnackBar('INVALID_PAYMENT_LINK');
        return;
      }

      this.customSale = await this.authService.getCustomSale(decoded.customSaleId);
      console.log('✅ Loaded Custom Sale:', this.customSale);

    } catch (error: any) {
      console.error('Payment Init Error:', error);
      this.commanUsesService.showSnackBar(error?.message || 'Something went wrong');
    } finally {
      this.spinnerService.hide();
    }
  }

  async ngAfterViewInit() {
    try {
      this.stripe = await loadStripe('pk_test_51S0KucPle1MW1pVpp2wWS7yRhkoy4X73oi0mrIJ9kY4o0LWWgKrDaJSk1WJYQQmILVBEViCMLzix5NdaP8EnWpgU00QCdS8rzE'); // ⚡ replace with real publishable key
      if (this.stripe) {
        this.elements = this.stripe.elements();
        this.card = this.elements.create('card', {
          style: {
            base: {
              fontSize: '16px',
              color: '#32325d',
              '::placeholder': { color: '#a0aec0' }
            },
            invalid: { color: '#e53e3e' }
          }
        });
        this.card.mount('#stripe-card-element');
      }
    } catch (err) {
      console.error('Stripe init error:', err);
      this.commanUsesService.showSnackBar('Stripe initialization failed');
    }

    try {
      this.paypal = await loadScript({
        clientId: 'test',
        currency: 'USD'
      });

      if (this.paypal) {
        this.paypal.Buttons({
          style: { layout: 'horizontal', color: 'blue', shape: 'pill', label: 'paypal' },
          createOrder: async () => {
            return 'ORDER_ID_FROM_BACKEND';
          },
          onApprove: async (data) => {
            console.log('✅ PayPal Approved', data);
            this.commanUsesService.showSnackBar('Payment successful via PayPal');
          },
          onError: (err) => {
            console.error('PayPal error', err);
            this.commanUsesService.showSnackBar('PayPal Payment Failed');
          }
        }).render('#paypal-button-container');
      }
    } catch (err) {
      console.error('PayPal init error:', err);
      this.commanUsesService.showSnackBar('PayPal initialization failed');
    }
  }

  async payWithStripe() {
    if (!this.stripe || !this.card) {
      this.commanUsesService.showSnackBar('Stripe not ready');
      return;
    }

    try {
      // 1. Ask backend for clientSecret
      const res = await this.CustomPaymentsService.createPaymentIntent(
        // (this.customSale?.totalAmount || 249) * 100 // in cents
        (249) * 100 // in cents
      );

      console.log("res", res)

      const clientSecret = res?.clientSecret;
      if (!clientSecret) throw new Error('No client secret received');

      // 2. Confirm payment
      const result = await this.stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: this.card,
          billing_details: { name: 'Testing Nicolo' }
        }
      });

      if (result.error) {
        this.commanUsesService.showSnackBar(result.error.message || 'Payment Failed');
      } else if (result.paymentIntent?.status === 'succeeded') {
        this.commanUsesService.showSnackBar('Payment successful via Stripe');
      }
    } catch (err: any) {
      console.error('Stripe Payment Error:', err);
      this.commanUsesService.showSnackBar(err?.message || 'Payment Failed');
    }
  }

  async payWithCheckout() {
    try {
      const res = await this.CustomPaymentsService
        .createCheckoutSession(24900, 'shopifysale'); // $249.00 in cents

      // if (res?.url) {
      //   window.location.href = res.url; // redirect to Stripe Checkout
      // }
    } catch (err) {
      console.error('Checkout error:', err);
      this.commanUsesService.showSnackBar('Failed to start Checkout');
    }
  }


  ngOnDestroy() {
    if (this.card) {
      this.card.destroy();
    }
  }
}
